module.exports = __webpack_public_path__ + "img/imersys_header.d0fe1ff5.jpeg";